import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './PilotDroneMissionQuickSearch.css';
import Sidebar from "../Sidebar/Sidebar";
import pavamanLogo from "../images/drone.png";
import {FiChevronLeft,FiChevronRight,FiClock,FiCalendar,FiFlag,FiAlertCircle,FiUser,FiLayers,FiList,FiX,FiPlayCircle} from 'react-icons/fi';
import { GiDeliveryDrone } from 'react-icons/gi';
import PopupMessage from "../PopupMessage/PopupMessage";
import { fetchPilotDroneMissionQuickSearch } from "../Apis/AdminApis";

const PilotDroneMissionQuickSearch = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);
  const [error, setError] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
const [filterType, setFilterType] = useState(
  () => sessionStorage.getItem("pilotMissionFilterType") || "day"
);

const [startDate, setStartDate] = useState(
  () => sessionStorage.getItem("pilotMissionStartDate") || ""
);

const [endDate, setEndDate] = useState(
  () => sessionStorage.getItem("pilotMissionEndDate") || ""
);
  const [pilotSearch, setPilotSearch] = useState(
  () => sessionStorage.getItem("pilotMissionSearchText") || ""
);
  const [selectedMinutes, setSelectedMinutes] = useState("");
  const [timeFilterType, setTimeFilterType] = useState("");
const [appliedSearchText, setAppliedSearchText] = useState(
  () => sessionStorage.getItem("pilotMissionSearch") || ""
);

const [appliedMinutes, setAppliedMinutes] = useState(
  () => sessionStorage.getItem("pilotMissionMinutes") || ""
);

const [appliedTimeFilterType, setAppliedTimeFilterType] = useState(
  () => sessionStorage.getItem("pilotMissionTimeFilterType") || ""
);
  const [currentPilotPage, setCurrentPilotPage] = useState(1);
  const [pilotsPerPage] = useState(2);
  const [currentMissionPage, setCurrentMissionPage] = useState(1);
  const [missionsPerPage] = useState(10);
  const [responseData, setResponseData] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchText, setSearchText] = useState(
  () => sessionStorage.getItem("pilotMissionSearchText") || ""
);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedPilot, setSelectedPilot] = useState(() => {
  const savedPilot = sessionStorage.getItem("pilotMissionSelectedPilot");

  try {
    return savedPilot ? JSON.parse(savedPilot) : null;
  } catch {
    return null;
  }
});
  const [searchTimeout, setSearchTimeout] = useState(null);
  
  const handleSessionExpired = useCallback(() => {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  localStorage.clear();

  setTimeout(() => {
    navigate("/login");
  }, 2000);
}, [navigate]);

useEffect(() => {

  if (!hasSearched) {
    return;
  }

  sessionStorage.setItem("pilotMissionFilterType", filterType);
  sessionStorage.setItem("pilotMissionStartDate", startDate);
  sessionStorage.setItem("pilotMissionEndDate", endDate);
  sessionStorage.setItem("pilotMissionSearch", appliedSearchText);
  sessionStorage.setItem("pilotMissionMinutes", appliedMinutes);
  sessionStorage.setItem(
    "pilotMissionTimeFilterType",
    appliedTimeFilterType
  );
  sessionStorage.setItem("pilotMissionSearchText", searchText);

  if (selectedPilot) {
    sessionStorage.setItem(
      "pilotMissionSelectedPilot",
      JSON.stringify(selectedPilot)
    );
  } else {
    sessionStorage.removeItem("pilotMissionSelectedPilot");
  }
}, [
  hasSearched,
  filterType,
  startDate,
  endDate,
  appliedSearchText,
  appliedMinutes,
  appliedTimeFilterType,
  searchText,
  selectedPilot
]);

  const fetchData = useCallback(async (
  page = currentPilotPage,
  missionPage = currentMissionPage,
  showLoading = true,
  filter = filterType
) => {
    try {
      if (showLoading) {
        setLoading(true);
        setIsPaginationLoading(false);
      } else {
        setIsPaginationLoading(true);
      }

      const payload = {
       filter_type: filter,
        pilot_search:
  appliedSearchText ||
  selectedPilot?.email ||
  pilotSearch ||
  undefined,
        pilot_page: page,
        pilots_per_page: pilotsPerPage,
        mission_page: missionPage,
        missions_per_page: missionsPerPage,
      };

      if (filter !== "custom") {
  payload.date = new Date().toISOString().split("T")[0];
}
      if (filter === 'custom') {
        if (!startDate || !endDate) {
          setError('Please select both start and end dates');
          setLoading(false);
          setIsPaginationLoading(false);
          return;
        }
        payload.start_date = startDate;
        payload.end_date = endDate;
      }
      if (appliedMinutes) {
  payload.time_value = `${parseFloat(appliedMinutes)}min`;
  payload.time_type = appliedTimeFilterType;
}
      const response = await fetchPilotDroneMissionQuickSearch(payload);

      // Handle session expiry / unauthorized response first
if (
  response?.error?.toLowerCase()?.includes("unauthorized") ||
  response?.message?.toLowerCase()?.includes("unauthorized")
) {
  handleSessionExpired();
  return;
}

if (response?.error) {
  setError(response.error);
  setResponseData(null);
  return;
}

      setResponseData(response);
      console.log("responseData.data =", response.data);
console.log("responseData.admin_companies =", response.admin_companies);
      setError(null);

   } catch (err) {
  if (
    err?.response?.status === 401 ||
    err?.response?.data?.error?.toLowerCase()?.includes("unauthorized") ||
    err?.message?.toLowerCase()?.includes("unauthorized")
  ) {
    handleSessionExpired();
    return;
  }

  setError("Failed to fetch data. Please try again.");
  console.error("Error fetching quick search data:", err);
} finally {
      if (showLoading) {
        setLoading(false);
      }
      setIsPaginationLoading(false);
    }
}, [
  filterType,
  startDate,
  endDate,
  currentPilotPage,
  currentMissionPage,
  pilotsPerPage,
  missionsPerPage,
  navigate,
  appliedSearchText,
  appliedMinutes,
  appliedTimeFilterType,
  selectedPilot,
  handleSessionExpired
]);
const [isRestoringSession, setIsRestoringSession] = useState(true);

useEffect(() => {
  const savedFilterType =
    sessionStorage.getItem("pilotMissionFilterType");

  const savedSearch =
    sessionStorage.getItem("pilotMissionSearch");

  const savedSearchText =
    sessionStorage.getItem("pilotMissionSearchText");

  const savedStartDate =
    sessionStorage.getItem("pilotMissionStartDate");

  const savedEndDate =
    sessionStorage.getItem("pilotMissionEndDate");

  const savedMinutes =
    sessionStorage.getItem("pilotMissionMinutes");

  const savedTimeFilterType =
    sessionStorage.getItem("pilotMissionTimeFilterType");

  const savedPilot =
    sessionStorage.getItem("pilotMissionSelectedPilot");

  let pilot = null;

  try {
    pilot = savedPilot ? JSON.parse(savedPilot) : null;
  } catch {
    pilot = null;
  }

  // IMPORTANT:
  // Only restore if the user actually searched before.
  if (!savedSearch && !savedPilot) {
    setIsRestoringSession(false);
    return;
  }

  const navigationState = window.history.state?.usr;

const savedPilotPage = navigationState?.pilotPage || 1;
const savedMissionPage = navigationState?.missionPage || 1;


  const restoreData = async () => {
    try {
      const restoredFilter = savedFilterType || "day";

      const payload = {
        filter_type: restoredFilter,
        pilot_page: savedPilotPage || 1,
        pilots_per_page: pilotsPerPage,
        mission_page: savedMissionPage || 1,
        missions_per_page: missionsPerPage,
      };

      if (restoredFilter !== "custom") {
        payload.date = new Date()
          .toISOString()
          .split("T")[0];
      }

      if (restoredFilter === "custom") {
        if (savedStartDate && savedEndDate) {
          payload.start_date = savedStartDate;
          payload.end_date = savedEndDate;
        }
      }

      if (savedSearch || pilot?.email) {
        payload.pilot_search =
          pilot?.email || savedSearch;
      }

      if (savedMinutes && savedTimeFilterType) {
        payload.time_value = `${parseFloat(savedMinutes)}min`;
        payload.time_type = savedTimeFilterType;
      }

      const response =
        await fetchPilotDroneMissionQuickSearch(payload);

      if (
        response?.error
          ?.toLowerCase()
          ?.includes("unauthorized") ||
        response?.message
          ?.toLowerCase()
          ?.includes("unauthorized")
      ) {
        handleSessionExpired();
        return;
      }

      if (response?.error) {
        setError(response.error);
        return;
      }

      setResponseData(response);
      setHasSearched(true);

      // Restore UI state
      setFilterType(restoredFilter);
      setSearchText(savedSearchText || savedSearch || "");
      setPilotSearch(savedSearch || "");
      setSelectedPilot(pilot);

      if (savedStartDate) {
        setStartDate(savedStartDate);
      }

      if (savedEndDate) {
        setEndDate(savedEndDate);
      }

      if (savedMinutes) {
        setSelectedMinutes(savedMinutes);
      }

      if (savedTimeFilterType) {
        setTimeFilterType(savedTimeFilterType);
      }

      setCurrentPilotPage(savedPilotPage || 1);
      setCurrentMissionPage(savedMissionPage || 1);

    } catch (err) {
      console.error(
        "Error restoring pilot mission search:",
        err
      );

      setError("Failed to restore previous search.");
    } finally {
      setIsRestoringSession(false);
    }
  };

  restoreData();

}, []);

const handleFilterChange = async (type) => {
  setFilterType(type);
if (type !== "custom") {
  setStartDate("");
  setEndDate("");
}
  if (type === "custom") {
    return;
  }

  try {
const payload = {
    filter_type: type,
    pilot_search:
        appliedSearchText ||
        selectedPilot?.email ||
        undefined,
    pilot_page: 1,
    pilots_per_page: pilotsPerPage,
    mission_page: 1,
    missions_per_page: missionsPerPage,
};

if (type !== "custom") {
    payload.date = new Date().toISOString().split("T")[0];
}

const response = await fetchPilotDroneMissionQuickSearch(payload);

if (
  response?.error?.toLowerCase()?.includes("unauthorized") ||
  response?.message?.toLowerCase()?.includes("unauthorized")
) {
  handleSessionExpired();
  return;
}

if (response?.error) {
  setError(response.error);
  return;
}

setResponseData(response);
setError(null);
} catch (err) {
  if (
    err?.response?.status === 401 ||
    err?.response?.data?.error?.toLowerCase()?.includes("unauthorized") ||
    err?.message?.toLowerCase()?.includes("unauthorized")
  ) {
    handleSessionExpired();
    return;
  }

  console.error(err);
  setError("Failed to fetch data. Please try again.");
}
};

const handleApplyFilters = async () => {
  if (
  filterType === "custom" &&
  (!startDate || !endDate)
) {
  setPopupMessage("Please select Start Date and End Date");
  setPopupType("warning");
  setPopupOpen(true);
  return;
}
  setAppliedSearchText(searchText);
  setAppliedMinutes(selectedMinutes);
  setAppliedTimeFilterType(timeFilterType);
sessionStorage.setItem(
  "pilotMissionFilterType",
  filterType
);

sessionStorage.setItem(
  "pilotMissionSearch",
  searchText
);

sessionStorage.setItem(
  "pilotMissionSearchText",
  searchText
);

sessionStorage.setItem(
  "pilotMissionMinutes",
  selectedMinutes
);

sessionStorage.setItem(
  "pilotMissionTimeFilterType",
  timeFilterType
);

sessionStorage.setItem(
  "pilotMissionStartDate",
  startDate
);

sessionStorage.setItem(
  "pilotMissionEndDate",
  endDate
);

if (selectedPilot) {
  sessionStorage.setItem(
    "pilotMissionSelectedPilot",
    JSON.stringify(selectedPilot)
  );
}
  setCurrentPilotPage(1);
  setCurrentMissionPage(1);

  const payload = {
    filter_type: filterType,
    pilot_page: 1,
    pilots_per_page: pilotsPerPage,
    mission_page: 1,
    missions_per_page: missionsPerPage,
  };

  if (filterType !== "custom") {
    payload.date = new Date().toISOString().split("T")[0];
  }

  if (filterType === "custom") {
    payload.start_date = startDate;
    payload.end_date = endDate;
  }

  if (selectedPilot?.email) {
    payload.pilot_search = selectedPilot.email;
  }

  if (selectedMinutes) {
    payload.time_value = `${selectedMinutes}min`;
    payload.time_type = timeFilterType;
  }

try {
  const response = await fetchPilotDroneMissionQuickSearch(payload);

  if (
    response?.error?.toLowerCase()?.includes("unauthorized") ||
    response?.message?.toLowerCase()?.includes("unauthorized")
  ) {
    handleSessionExpired();
    return;
  }

  if (response?.error) {
    setError(response.error);
    setResponseData(null);
    return;
  }

  setResponseData(response);
  setHasSearched(true);
  setError(null);

} catch (err) {
  if (
    err?.response?.status === 401 ||
    err?.response?.data?.error?.toLowerCase()?.includes("unauthorized") ||
    err?.message?.toLowerCase()?.includes("unauthorized")
  ) {
    handleSessionExpired();
    return;
  }

  console.error("Error applying filters:", err);
  setError("Failed to fetch data. Please try again.");
}
};

const handleClearFilters = () => {

  sessionStorage.removeItem("pilotMissionFilterType");
  sessionStorage.removeItem("pilotMissionStartDate");
  sessionStorage.removeItem("pilotMissionEndDate");
  sessionStorage.removeItem("pilotMissionSearch");
  sessionStorage.removeItem("pilotMissionSearchText");
  sessionStorage.removeItem("pilotMissionMinutes");
  sessionStorage.removeItem("pilotMissionTimeFilterType");
  sessionStorage.removeItem("pilotMissionSelectedPilot");

  setSearchText("");
  setPilotSearch("");
  setSelectedPilot(null);

  setSuggestions([]);
  setShowSuggestions(false);

  setSelectedMinutes("");
  setTimeFilterType("");

  setAppliedSearchText("");
  setAppliedMinutes("");
  setAppliedTimeFilterType("");

  setFilterType("day");

  setStartDate("");
  setEndDate("");

  setCurrentPilotPage(1);
  setCurrentMissionPage(1);

  setResponseData(null);
  setHasSearched(false);
};

const handleResetFilters = () => {
  setFilterType("day");

  setStartDate("");
  setEndDate("");

  setPilotSearch("");

  setSearchText("");
  setSelectedPilot(null);

  setSuggestions([]);
  setShowSuggestions(false);

  setSelectedMinutes("");
  setTimeFilterType("");

  setAppliedSearchText("");
  setAppliedMinutes("");
  setAppliedTimeFilterType("");

  setCurrentPilotPage(1);
  setCurrentMissionPage(1);

  fetchData(1, 1, true, "day");
};

  const handlePilotPageChange = (newPage) => {
    if (newPage >= 1 && newPage <= getTotalPilotPages()) {
      setCurrentPilotPage(newPage);
      fetchData(newPage, currentMissionPage, false);
    }
  };

  const handleMissionPageChange = (pilotId, newPage, totalPages) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentMissionPage(newPage);
    fetchData(currentPilotPage, newPage, false);
  };

  const getTotalPilotPages = () => {
    if (!responseData?.pilot_pagination) return 1;
    return responseData.pilot_pagination.total_pages || 1;
  };

  const getTotalPilots = () => {
    if (!responseData?.pilot_pagination) return 0;
    return responseData.pilot_pagination.total_pilots || 0;
  };

  const getPilotData = () => {
    if (!responseData?.data) return [];
    return responseData.data;
  };

  const getPilotMissions = (pilot) => {
    return pilot.missions || [];
  };



  const formatTimeAgo = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins}m ago`;
      if (diffHours < 24) return `${diffHours}h ago`;
      if (diffDays < 30) return `${diffDays}d ago`;
      return date.toLocaleDateString();
    } catch {
      return dateString;
    }
  };

// const handlePilotSearch = (e) => {
//   const value = e.target.value;

//   setSearchText(value);

//   if (searchTimeout) {
//     clearTimeout(searchTimeout);
//   }

//   if (value.length < 2) {
//     setSuggestions([]);
//     setShowSuggestions(false);
//     return;
//   }

//   const timeout = setTimeout(async () => {
//     try {
//  const response = await fetchPilotDroneMissionQuickSearch({
//   filter_type: filterType,
//   date: new Date().toISOString().split("T")[0],
//   pilot_search: value,
//   suggestions_only: true
// });

// if (
//   response?.error?.toLowerCase()?.includes("unauthorized") ||
//   response?.message?.toLowerCase()?.includes("unauthorized")
// ) {
//   handleSessionExpired();
//   return;
// }

// if (response?.error) {
//   console.error("Suggestion API error:", response.error);
//   return;
// }

// setSuggestions(response.suggestions || []);
// setShowSuggestions(true);

//    } catch (err) {
//   if (
//     err?.response?.status === 401 ||
//     err?.response?.data?.error?.toLowerCase()?.includes("unauthorized") ||
//     err?.message?.toLowerCase()?.includes("unauthorized")
//   ) {
//     handleSessionExpired();
//     return;
//   }

//   console.error("Error fetching pilot suggestions:", err);
// }
//   }, 500);

//   setSearchTimeout(timeout);
// };

const handlePilotSearch = (e) => {
  const value = e.target.value;

  setSearchText(value);

  // Clear previous debounce timer
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }

  // Clear suggestions when input is empty
  if (value.trim().length < 1) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  const timeout = setTimeout(async () => {
    try {
      const response = await fetchPilotDroneMissionQuickSearch({
        filter_type: filterType,
        date: new Date().toISOString().split("T")[0],
        pilot_search: value.trim(),
        suggestions_only: true
      });

      // Session expired
      if (
        response?.error?.toLowerCase()?.includes("unauthorized") ||
        response?.message?.toLowerCase()?.includes("unauthorized")
      ) {
        handleSessionExpired();
        return;
      }

      // API error
      if (response?.error) {
        console.error(
          "Suggestion API error:",
          response.error
        );

        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      // Set suggestions
      setSuggestions(response?.suggestions || []);
      setShowSuggestions(true);

    } catch (err) {

      // Handle unauthorized/session expiry
      if (
        err?.response?.status === 401 ||
        err?.response?.data?.error
          ?.toLowerCase()
          ?.includes("unauthorized") ||
        err?.message
          ?.toLowerCase()
          ?.includes("unauthorized")
      ) {
        handleSessionExpired();
        return;
      }

      console.error(
        "Error fetching pilot suggestions:",
        err
      );

      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, 500);

  setSearchTimeout(timeout);
};

const handlePilotSelect = async (pilot) => {

setSelectedPilot(pilot);
setPilotSearch(pilot.email);
setSearchText(pilot.email);
setAppliedSearchText(pilot.email);

sessionStorage.setItem(
  "pilotMissionSelectedPilot",
  JSON.stringify(pilot)
);

sessionStorage.setItem(
  "pilotMissionSearch",
  pilot.email
);

sessionStorage.setItem(
  "pilotMissionSearchText",
  pilot.email
);

sessionStorage.setItem(
  "pilotMissionFilterType",
  filterType
);

setShowSuggestions(false);

  setShowSuggestions(false);
  try {
     const payload = {
    filter_type: filterType,
    pilot_search: pilot.email || pilot.pilot_email,
    pilot_page: 1,
    mission_page: 1
};

if (filterType !== "custom") {
    payload.date = new Date().toISOString().split("T")[0];
}

const response = await fetchPilotDroneMissionQuickSearch(payload);

if (
  response?.error?.toLowerCase()?.includes("unauthorized") ||
  response?.message?.toLowerCase()?.includes("unauthorized")
) {
  handleSessionExpired();
  return;
}

if (response?.error) {
  setError(response.error);
  return;
}

setResponseData(response);
setHasSearched(true);
setError(null);

  } catch (err) {
    if (
      err?.response?.status === 401 ||
      err?.response?.data?.error?.toLowerCase()?.includes("unauthorized") ||
      err?.message?.toLowerCase()?.includes("unauthorized")
    ) {
      handleSessionExpired();
      return;
    }

    console.error("Error fetching pilot data:", err);
      setError("Failed to fetch pilot data.");
  }
};

const handleMissionReplay = (mission, pilot) => {
  const pilotId =
    mission.pilot_id ||
    (mission.events?.length > 0 && mission.events[0]?.pilot_id) ||
    pilot?.pilot_id ||
    localStorage.getItem("pilot_id") ||
    "default_pilot_id";

  const missionData = {
    mission_id: mission.mission_id,
    vehicle_id: mission.drone_id,
    pilot_id: pilotId,
    drone_name: mission.drone_name || pilot?.drone_name,
    pilot_name: mission.pilot_name || pilot?.pilot_name,
    mission_status: mission.status || mission.mission_status,
    fromPage: "pilot-mission-search",
  };

  console.log("MISSION REPLAY DATA:", missionData);

  if (
    missionData.mission_id &&
    missionData.vehicle_id &&
    missionData.pilot_id
  ) {
   navigate("/admin/mission-replay", {
  state: {
    missionData,
    from: "pilot-drone-quick-search",
    pilotPage: currentPilotPage,
    missionPage: currentMissionPage,
    filters: {
      filterType,
      startDate,
      endDate,
      appliedSearchText,
      appliedMinutes,
      appliedTimeFilterType,
      searchText,
    },
  },
});
  } else {
    alert(
      `Missing required data: mission_id=${missionData.mission_id}, vehicle_id=${missionData.vehicle_id}, pilot_id=${missionData.pilot_id}`
    );
  }
};

const dashboardStats = useMemo(() => {
  if (!responseData?.data?.length) {
    return {
      totalAcres: 0,
      totalMissions: 0,
      totalDuration: 0
    };
  }

  return responseData.data.reduce(
    (totals, pilot) => ({
      totalAcres:
        totals.totalAcres +
        Number(
          pilot.total_sprayed_acres ??
          pilot.total_acres ??
          0
        ),

      totalMissions:
        totals.totalMissions +
        Number(
          pilot.total_missions ?? 0
        ),

      totalDuration:
        totals.totalDuration +
        Number(
          pilot.total_flight_hours ?? 0
        )
    }),
    {
      totalAcres: 0,
      totalMissions: 0,
      totalDuration: 0
    }
  );
}, [responseData]);


  const getMissionStatusColor = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower.includes('active') || statusLower.includes('in progress')) {
      return { label: 'Active', color: '#10B981', bg: '#D1FAE5' };
    } else if (statusLower.includes('completed') || statusLower.includes('finished')) {
      return { label: 'Completed', color: '#3B82F6', bg: '#DBEAFE' };
    } else if (statusLower.includes('failed') || statusLower.includes('error')) {
      return { label: 'Failed', color: '#EF4444', bg: '#FEE2E2' };
    } else if (statusLower.includes('pending')) {
      return { label: 'Pending', color: '#F59E0B', bg: '#FEF3C7' };
    } else {
      return { label: 'Unknown', color: '#6B7280', bg: '#F3F4F6' };
    }
  };

  const isApiEmpty =
  hasSearched &&
  (!responseData?.data || responseData.data.length === 0);
  const isSearchEmpty =
  selectedPilot &&
  responseData?.data &&
  responseData.data.length === 0;

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">
              Pilot & Drone Mission Search
            </h1>
            <p className="dashboard-subtitle">
              Search and monitor pilot activities, drone missions, and events in real-time
            </p>
          </div>
          <div className="header-right">
            
              <div className="pq-date-pill">
    <FiCalendar className="pq-date-icon" />

    <span>
      {new Date().toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
      })}
    </span>
  </div>
           {selectedPilot && (
  <>
<div className="date-range">
  <div className="ad-time-buttons">
    {["day", "week", "month", "year", "custom"].map((range) => (
      <button
        key={range}
        className={`ad-time-btn ${
          filterType === range ? "active" : ""
        }`}
        onClick={() => handleFilterChange(range)}
      >
        {range.charAt(0).toUpperCase() + range.slice(1)}
      </button>
    ))}
  </div>
</div>
  </>
)}
          </div>
        </div>
{filterType === "custom" && (
  <div className="filters-section-flights">
   <div className="filters-grid">
  <div className="filter-group">
 <label>Start Date</label>
    <input
      type="date"
      className="filter-input"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
</div>
    <div className="filter-group">
       <label>End Date</label>
    <input
      type="date"
      className="filter-input"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
</div>
</div>
  <div className="filter-actions">
    <button
      className="apply-filters-btn"
      onClick={handleApplyFilters}
    >
      Apply
    </button>
     <button className="reset-filters-btn" onClick={handleResetFilters}>
                Reset
              </button>
    </div>

  </div>

)}

       {filterType && (
  <div className="pq-active-filters">
    <div className="pq-filter-info">
      <div className="pq-filter-icon">
        <FiCalendar size={18} />
      </div>

      <div className="pq-filter-text">
        <span className="pq-filter-title">
          Active Filter
        </span>

        <span className="pq-filter-value">
         {filterType === "custom"
    ? `${responseData?.start_date || startDate} → ${responseData?.end_date || endDate}`
    : `${filterType.charAt(0).toUpperCase()}${filterType.slice(1)} View`}
        </span>
      </div>
    </div>

    <div className="pq-filter-right">
      <div className="pq-total-badge">
        <FiUser size={15} />
        <span>{getTotalPilots()} Pilot{getTotalPilots() > 1 ? "s" : ""}</span>
      </div>

      {responseData?.data?.length > 0 && (
        <div className="pq-mission-badge">
          <FiLayers size={15} />
          <span>
            {dashboardStats.totalMissions} Missions
          </span>
        </div>
      )}

    </div>
  </div>
)}

    <div
  className="table-controls"
  style={{ marginBottom: "20px", flexWrap: "wrap" }}
>
  <div className="pilot-search-wrapper">
    <input
      type="text"
      placeholder="Search by Pilot Name or Email..."
      className="pilot-search-input"
      value={searchText}
      onChange={handlePilotSearch}
    />

    {showSuggestions && suggestions.length > 0 && (
      <div className="pq-search-dropdown">
        {suggestions.map((pilot) => (
          <div
            key={pilot.pilot_id}
            className="pq-search-item"
            onClick={() => handlePilotSelect(pilot)}
          >
            <div className="pq-search-name">
              {pilot.pilot_name}
            </div>

            <div className="pq-search-email">
              {pilot.email}
            </div>
          </div>
        ))}
      </div>
    )}

    {searchText && (
      <button
        className="pv-clear-search"
       onClick={() => {
    setSearchText("");
    setPilotSearch("");
    setSelectedPilot(null);

    setAppliedSearchText("");

    setSuggestions([]);
    setShowSuggestions(false);

    setResponseData(null);
setHasSearched(false);
}}
      >
       <FiX size={18} />
      </button>
    )}
  </div>

  <div className="pilot-time-filter">
    <div className="clock-icon">⏰</div>

    <select
      className="pilot-filter-select"
      value={timeFilterType}
      onChange={(e) => setTimeFilterType(e.target.value)}
    >
      <option value="">Select Comparison</option>
      <option value="lt">Shorter than (less than)</option>
      <option value="gt">Longer than (greater than)</option>
      <option value="eq">Approx Equal to</option>
    </select>

    <input
      type="number"
      min="0.5"
      max="120"
      step="0.5"
      className="minute-input"
      placeholder="Minutes"
      value={selectedMinutes}
      onChange={(e) => setSelectedMinutes(e.target.value)}
    />

    <span className="minute-label">Minutes</span>

    <button
      className="apply-filter-btn"
      onClick={handleApplyFilters}
    >
      Apply Filters
    </button>

    <button
      className="reset-filters-btn"
      onClick={handleClearFilters}
    >
      Clear Filters
    </button>
  </div>
</div>
{selectedPilot && (
  <div className="stats-grid">
    <div className="stat-card">
      <div
        className="stat-icon"
        style={{
          background:
            "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        }}
      >
        <span className="icon">🌾</span>
      </div>

      <div className="stat-content">
        <p className="stat-label">Total Acres Sprayed</p>
        <h3 className="stat-value">
          {dashboardStats.totalAcres.toFixed(2)}
        </h3>
      </div>
    </div>

    <div className="stat-card">
      <div
        className="stat-icon"
        style={{
          background:
            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <img
          src={require("../images/drone image.png")}
          alt="Drone"
          className="drone-icon"
        />
      </div>

      <div className="stat-content">
        <p className="stat-label">Total Missions</p>
        <h3 className="stat-value">
          {dashboardStats.totalMissions}
        </h3>
      </div>
    </div>

    <div className="stat-card">
      <div
        className="stat-icon"
        style={{
          background:
            "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
        }}
      >
        <span className="icon">⏱️</span>
      </div>

    <div className="stat-content">
  <p className="stat-label">Total Flight Time</p>
  <h3 className="stat-value">
  {Math.floor(dashboardStats.totalDuration)} hrs{" "}
  {Math.round(
    (dashboardStats.totalDuration -
      Math.floor(dashboardStats.totalDuration)) * 60
  )} min
</h3>
</div>
    </div>

  </div>
)}
        {error && (
          <div className="pq-error">
            <FiAlertCircle className="pq-error-icon" />
            <span>{error}</span>
            <button onClick={() => fetchData(currentPilotPage, currentMissionPage, true)} className="pq-error-retry">
              Retry
            </button>
          </div>
        )}

        {(loading && !isPaginationLoading) ? (
          <div className="pq-loading">
            <img src={pavamanLogo} alt="Loading" className="pq-spinning-logo" />
            <p className="pq-loading-text">Searching pilot and drone mission data...</p>
          </div>
        ) : !hasSearched ? (
  <div className="pq-empty">
    <div className="pq-empty-icon">🔍</div>
    <h3>Search for a Pilot</h3>
    <p>
      Enter a Pilot Name, Email or Mission ID to view mission details.
    </p>
  </div>
) : isApiEmpty ? (
  <div className="pq-empty">
    <div className="pq-empty-icon">🔍</div>
    <h3>No Data Found</h3>
    <p>No pilots or missions found for the selected filters.</p>
  </div>
) : isSearchEmpty ? (
  <div className="pq-empty">
    <div className="pq-empty-icon">🔍</div>
    <h3>No Search Results</h3>
    <p>No pilots match your search criteria.</p>

    <button
      onClick={() => {
  setSearchText("");
  setSelectedPilot(null);
  setPilotSearch("");
  setSuggestions([]);
  setShowSuggestions(false);

  setFilterType("day");
  setStartDate("");
  setEndDate("");

  fetchData(1, 1, true);
}}
      className="pq-empty-btn"
    >
      Clear Search
    </button>

  </div>
) : (
          <>
            <div className="pq-pilots-list">
              {responseData?.data?.map((pilot) => {
                const pilotMissions = getPilotMissions(pilot);
                const totalMissions = pilot.missions_pagination?.total_missions || 0;

                return (
                  <div key={pilot.pilot_id} className="pq-pilot-card">
                    <div className="pq-pilot-header expanded">
                      <div className="pq-pilot-avatar">
                        <FiUser size={24} />
                      </div>

                      <div className="pq-pilot-info">
                        <h3 className="pq-pilot-name">
                          {pilot.pilot_name || pilot.pilot_id || 'Unknown Pilot'}
                        </h3>
                        <div className="pq-pilot-meta">
                          
                         {(pilot.email || pilot.pilot_email) && (
  <span className="pq-pilot-email">
    {pilot.email || pilot.pilot_email}
  </span>
)}
                          {pilot.drone_name && (
                            <span className="pq-pilot-drone">
                              <GiDeliveryDrone size={14} />
                              {pilot.drone_name}
                            </span>
                          )}
                         
                        </div>
                      </div>

                      <div className="pq-pilot-stats">
                        <div className="pq-stat-badge">
                          <FiLayers size={16} />
                          <span>{totalMissions} Missions</span>
                        </div>
                        {pilot.missions?.[0]?.start_time && (
                          <div className="pq-stat-badge">
                            <FiClock size={16} />
                            <span>{formatTimeAgo(pilot.missions[0].start_time)}</span>
                          </div>
                        )}
                      </div>
                    </div>

                      <div className="pq-pilot-missions">
                        <div className="pq-missions-header">
                          <h4>
                            <FiList className="pq-missions-icon" />
                            Mission History
                          </h4>
                        
                        </div>

                        {pilotMissions.length > 0 ? (
                          pilotMissions.map((mission) => {
                            const missionStatus = getMissionStatusColor(mission.status);
                            

                            return (
                              <div key={mission.mission_id} className="pq-mission-item">
                                <div className="pq-mission-header">
                                  <div className="pq-mission-icon-wrapper">
                                    <FiFlag className="pq-mission-icon" />
                                  </div>
                                  <div className="pq-mission-info">
                                    <span className="pq-mission-id">Mission ID: {mission.mission_id}</span>
                                    {mission.drone_name && (
                                      <span className="pq-mission-drone">
                                        <GiDeliveryDrone size={14} />
                                        <span className="pq-mission-id">Drone Name: {mission.drone_name}</span>
                                      </span>
                                    )}
                                    <span 
                                      className="pq-mission-status"
                                      style={{ 
                                        color: missionStatus.color,
                                        backgroundColor: missionStatus.bg 
                                      }}
                                    >
                                      {missionStatus.label}
                                    </span>
                                  </div>
                                  <div className="pq-mission-stats">
                                    <span className="pq-mission-events-count">
  {mission.total_acres} Acres
</span>
                                    {mission.duration && (
                                      <span className="pq-mission-duration">
                                        ⏱️ {mission.duration}
                                      </span>
                                    )}
                                        <button 
      className="me-replay-btn"
      onClick={(e) => {
        e.stopPropagation();
        handleMissionReplay(mission, pilot);
      }}
      title="Replay Mission"
    >
      <FiPlayCircle size={16} />
      Replay
    </button>
                                  </div>
        
                                </div>

<div className="pq-mission-details-grid">

  <div className="pq-detail-card">
    <span className="pq-label">Mission Date</span>
    <span>{mission.mission_date || "-"}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Project</span>
    <span>{mission.project_name || "-"}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Plot</span>
    <span>{mission.plot_name || "-"}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Crop</span>
    <span>{mission.crop_type || "-"}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Total Acres</span>
    <span>{mission.total_acres || 0}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Sprayed Acres</span>
    <span>{mission.sprayed_acres || 0}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Flight Minutes</span>
    <span>{mission.flight_minutes || 0}</span>
  </div>

  <div className="pq-detail-card">
    <span className="pq-label">Status</span>
    <span>{mission.status || "-"}</span>
  </div>

</div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="pq-no-missions">
                            <FiAlertCircle />
                            <p>No missions found for this pilot</p>
                          </div>
                        )}
                      </div>
{pilot.missions_pagination?.total_pages > 1 && (
  <div className="pv-pilot-pagination-wrapper">
    <div className="pv-pilot-pagination-controls">
      <button
        className="pv-pilot-pagination-btn"
        onClick={() =>
          handleMissionPageChange(
            pilot.pilot_id,
            pilot.missions_pagination.current_page - 1,
            pilot.missions_pagination.total_pages
          )
        }
        disabled={
          pilot.missions_pagination.current_page === 1 ||
          isPaginationLoading
        }
      >
        <FiChevronLeft size={16} />
        Previous
      </button>

      <div className="pv-pilot-page-numbers">
        {Array.from(
          {
            length: Math.min(
              5,
              pilot.missions_pagination.total_pages
            ),
          },
          (_, i) => {
            let pageNumber;
            const totalPages = pilot.missions_pagination.total_pages;
            const currentPage =
              pilot.missions_pagination.current_page;

            if (totalPages <= 5) {
              pageNumber = i + 1;
            } else if (currentPage <= 3) {
              pageNumber = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNumber = totalPages - 4 + i;
            } else {
              pageNumber = currentPage - 2 + i;
            }

            return (
              <button
                key={pageNumber}
                className={`pv-pilot-page-btn ${
                  currentPage === pageNumber
                    ? "pv-pilot-active"
                    : ""
                }`}
                onClick={() =>
                  handleMissionPageChange(
                    pilot.pilot_id,
                    pageNumber,
                    totalPages
                  )
                }
                disabled={isPaginationLoading}
              >
                {pageNumber}
              </button>
            );
          }
        )}
      </div>

      <button
        className="pv-pilot-pagination-btn"
        onClick={() =>
          handleMissionPageChange(
            pilot.pilot_id,
            pilot.missions_pagination.current_page + 1,
            pilot.missions_pagination.total_pages
          )
        }
        disabled={
          pilot.missions_pagination.current_page ===
            pilot.missions_pagination.total_pages ||
          isPaginationLoading
        }
      >
        Next
        <FiChevronRight size={16} />
      </button>
    </div>
  </div>
)}
                  </div>
                );
              })}
            </div>

            {getTotalPilotPages() > 1 && (
              <div className="pq-pagination-wrapper">
                <div className="pq-pagination-controls">
                  <button
                    className="pq-pagination-btn"
                    onClick={() => handlePilotPageChange(currentPilotPage - 1)}
                    disabled={currentPilotPage === 1 || isPaginationLoading}
                  >
                    <FiChevronLeft size={16} />
                    Previous
                  </button>

                  <div className="pq-page-numbers">
                    {Array.from({ length: Math.min(5, getTotalPilotPages()) }, (_, i) => {
                      let pageNumber;
                      const totalPages = getTotalPilotPages();
                      if (totalPages <= 5) {
                        pageNumber = i + 1;
                      } else if (currentPilotPage <= 3) {
                        pageNumber = i + 1;
                      } else if (currentPilotPage >= totalPages - 2) {
                        pageNumber = totalPages - 4 + i;
                      } else {
                        pageNumber = currentPilotPage - 2 + i;
                      }
                      return (
                        <button
                          key={pageNumber}
                          className={`pq-page-btn ${currentPilotPage === pageNumber ? 'pq-active' : ''}`}
                          onClick={() => handlePilotPageChange(pageNumber)}
                          disabled={isPaginationLoading}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                  </div>

                  <button
                    className="pq-pagination-btn"
                    onClick={() => handlePilotPageChange(currentPilotPage + 1)}
                    disabled={currentPilotPage === getTotalPilotPages() || isPaginationLoading}
                  >
                    Next
                    <FiChevronRight size={16} />
                  </button>
                </div>
                <div className="pq-pagination-info">
                  Showing {responseData?.data?.length || 0} of {getTotalPilots()} pilots
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PilotDroneMissionQuickSearch;